import { convertProperty, removeProperty } from '@namphuongtechnologi/utils';
import type { Method } from 'axios';

import type { CreateReqMiddleWare } from '../type';

const defaultMethods = ['put', 'post', 'delete'];
const defaultStartWithChar = '__';

/**
 * @example
 * import type { Method } from 'axios';
 *
 *  export const exampleReqMiddleWare = ReqMiddleWare.create<{
 *   methods: Method[];
 *  }>({
 *      handler: (config, options) => {
 *       const { methods = ['put', 'post'] } = options || {};
 *
 *       if (config.data instanceof FormData) {
 *          return config;
 *       }
 *
 *       if (config.method && methods.includes(config.method)) {
 *          return {
 *              ...config,
 *              data: override(data), // override data
 *          };
 *       }
 *
 *       return config;
 *      },
 *  });
 */
const create: CreateReqMiddleWare = (params) => {
  const { handler } = params;

  return (options) => (onFulfilled) => (config) => onFulfilled(handler(config, options));
};

const removeFields = create<{
  startWithChar?: string;
  methods?: Method[];
}>({
  handler: (config, options) => {
    const { startWithChar = defaultStartWithChar, methods = defaultMethods } = options || {};

    if (config.data instanceof FormData) {
      return config;
    }

    if (config.method && methods.includes(config.method)) {
      return {
        ...config,
        data: removeProperty(config.data, (key) => key.startsWith(startWithChar)),
      };
    }

    return config;
  },
});

const convertPascalCase = create<{
  methods?: Method[];
}>({
  handler: (config, options) => {
    const { methods = defaultMethods } = options || {};

    if (config.data instanceof FormData) {
      return config;
    }

    if (config.method && methods.includes(config.method)) {
      return { ...config, data: convertProperty(config.data).toPascalCase() };
    }

    return config;
  },
});

export const ReqMiddleWare = {
  create,
  removeFields,
  convertPascalCase,
};
